import { render, staticRenderFns } from "./GotoPayment.vue?vue&type=template&id=3c978b36&scoped=true"
import script from "./GotoPayment.vue?vue&type=script&lang=js"
export * from "./GotoPayment.vue?vue&type=script&lang=js"
import style0 from "./GotoPayment.vue?vue&type=style&index=0&id=3c978b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c978b36",
  null
  
)

export default component.exports